import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { createAnalyticsInteract } from 'store/player/playerAsync';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';

const ProceedData:FC = () => {
  const { t } = useTranslation('common');
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const handleProceedClick = () => {
    // if ( !quiz.proceedClickBonusPoints ) return;

    dispatch(createAnalyticsInteract({
      result: result.currentUserResult._id,
      name: 'proceedClick'
    }));
    // dispatch(increaseScore({
    //   resultId: result.currentUserResult._id,
    //   data: {
    //     numberOfPoints: quiz.proceedClickBonusPoints,
    //     interaction: 'proceedClick'
    //   }
    // }));
  }

  if ( quiz.type === QuizTypes.Personality ) return null;
  if ( !quiz.proceedEnabled || !quiz.proceedUrl ) return null;
  return (
    <Fragment>
      {quiz.proceedImage ? (
        <a
          className="block shadow-neu-content rounded mb-4 overflow-hidden"
          href={quiz.proceedUrl}
          target="_blank"
          rel="noreferrer"
          onClick={handleProceedClick}
        ><img src={quiz.proceedImage} alt={quiz.proceedText || `${t('common.visit')} ${quiz.namespace}`} /></a>
      ) : null}
      {quiz.proceedClickBonusPoints ? (
        <h3 className="text-center text-sm text-blue-500 font-bold mb-2 px-4">{t('quiz.postQuizPage.earnAdditionalPoints', { points: quiz.proceedClickBonusPoints })}</h3>
      ) : null}
      <div className="text-center">
        <a
          className="
            inline-block
            rounded-2xl
            shadow-neu active:shadow-neu-inner
            font-semibold
            py-2 px-4
            text-white
          "
          style={{ backgroundColor: quiz.callToActionColor }}
          href={quiz.proceedUrl}
          target="_blank"
          rel="noreferrer"
          onClick={handleProceedClick}
        >{quiz.proceedText || `${t('common.visit')} ${quiz.namespace}`}</a>
      </div>
    </Fragment>
  )
}

export default ProceedData;
